import { TagTheme } from './interfaces';

export const TAG_STYLE_MAP: Partial<
  Record<TagTheme, { backgroundColor: string; tagClass: string; textColor: string }>
> = {
  [TagTheme.ACTIVE]: {
    backgroundColor: 'nordic-blue-900-bg surface-contrast',
    tagClass: '',
    textColor: 'white-text text-icon-reversed',
  },
  [TagTheme.ALERT]: {
    backgroundColor: 'error-50-bg signal-error-notification-bg',
    tagClass: '',
    textColor: 'nordic-blue-900-text text-icon-primary',
  },
  [TagTheme.BLACK_FRIDAY]: {
    backgroundColor: 'black-bg surface-contrast',
    tagClass: 'tag-black-friday',
    textColor: 'white-text text-icon-reversed',
  },
  [TagTheme.DEFAULT]: {
    backgroundColor: 'nordic-blue-25-bg surface-secondary',
    tagClass: 'tag-default',
    textColor: 'nordic-blue-900-text text-icon-primary',
  },
  [TagTheme.DEFAULT_ON_BG]: {
    backgroundColor: '',
    tagClass: 'tag-default-on-bg',
    textColor: '',
  },
  [TagTheme.DISABLED]: {
    backgroundColor: 'grey-200-bg surface-disabled-bg',
    tagClass: 'tag-disabled',
    textColor: 'grey-600-text text-icon-disabled-text',
  },
  [TagTheme.DISRUPTION]: {
    backgroundColor: 'error-50-bg',
    tagClass: '',
    textColor: 'error-900-text',
  },
  [TagTheme.ERROR]: {
    backgroundColor: '',
    tagClass: 'tag-error',
    textColor: '',
  },
  [TagTheme.POPULAR]: {
    backgroundColor: 'heather-700-bg surface-secondary',
    tagClass: '',
    textColor: 'white-text text-icon-reversed',
  },
  [TagTheme.PROMOTION]: {
    backgroundColor: '',
    tagClass: 'tag-promotion',
    textColor: '',
  },
  [TagTheme.SUCCESS]: {
    backgroundColor: 'success-50-bg signal-success-notification-bg',
    tagClass: 'tag-success',
    textColor: 'nordic-blue-900-text text-icon-primary',
  },
  [TagTheme.SUSTAINABILITY]: {
    backgroundColor: 'birch-50-bg',
    tagClass: '',
    textColor: 'birch-600-text',
  },
  [TagTheme.WARNING]: {
    backgroundColor: 'alert-50-bg',
    tagClass: 'tag-warning',
    textColor: 'nordic-blue-900-text text-icon-primary',
  },
  [TagTheme.WHITE]: {
    backgroundColor: 'white-bg surface-primary',
    tagClass: '',
    textColor: 'nordic-blue-900-text text-icon-primary',
  },
};
